<template>
  <v-container class="pa-0 ma-0" id="mainhomecontainer">
    <v-card>
      <!-- <div class="pl-2 pt-2" style="font-size:10px;">AF FoodItemCreate</div> -->
      <!-- <v-overlay v-model="overlay"
            :color= "business.themecolor!=NULL?business.themecolor:'#FE5800'" >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay> -->
      <v-overlay v-model="overlay"
            color= "#FE5800" >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
<!-- HEADER TOGGELS        -->
      <v-row>
          <v-col cols="2" md="2">
            <!-- <img :src="logo" height="28" /> -->
          </v-col>
          <v-col cols="10" md="10" class="text-center">
            <h4 class="title">{{$t('zz_add_food_item')}}</h4>
          </v-col>
        </v-row>
      <v-divider></v-divider>
      <v-container>
        <v-row align="left">
        <v-col cols="3" md="3" class="font-weight-bold" style="font-size:18px;" >
          {{$t('zz_show_on_juZZap')}}
        </v-col>
        <v-col cols="3" md="3">
          <v-switch label="" v-model="showonmenu" color="success"></v-switch>
        </v-col>
      </v-row>

      <v-row align="left">
        <v-col cols="3" md="3" class="font-weight-bold" style="font-size:18px;" >
          {{$t('zz_separator')}}
        </v-col>
        <v-col cols="3" md="3">
          <v-switch label="" v-model="separator" color="success"></v-switch>
        </v-col>
      </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-container>

<!-- NEW IPHONE CODE -->

        <!-- <v-form v-model="valid" enctype="multipart/form-data" id="createitem" ref="form"  autocomplete="off">
          <v-container elevation="0" class="relative cards-container ma-0 pa-3 bgg">
            <v-container elevation="0" style="min-width:400px;position:sticky;top:75px;height:fit-content;" class="card-preview card-in-cards-container">
              <v-img style="position:relative" class="true-center" :src="iphone"></v-img>
              <v-container class="preview-cards-container">
                
                <v-card v-if="!separator" elevation="6" class="new-food-tiem-preview-card pa-0">
                IMAGE
                </v-card>
                
                <v-card v-if="separator" elevation="6" class="edit-food-card">
                  Title & Text
                </v-card>
                
                <v-card elevation="6" class="edit-food-card2 pa-0">
                  Allergens
                </v-card>
              
              </v-container>


            </v-container>

          </v-container>
        
        </v-form> -->

<!-- ORIGINAL WORKING CODE -->
        <v-form v-model="valid" enctype="multipart/form-data" id="createitem" ref="form"  autocomplete="off">
          <v-container >
            <v-container class="cards-container mb-12" style="align-items: start">

<!-- *******************       PREVIEW CARD     ***************************-->
              <!-- <v-card v-if="!separator" class="d-none d-md-block card-preview pa-5 ma-12"> -->
              <v-card elevation="0" class="card-preview overflow-y-auto pa-0 ma-0" max-height="90vh">

                <!-- <v-container elevation="0" style="min-width:400px;position:sticky;top:75px;" class="card-in-cards-container bgm">
                  <v-img style="position:relative" class="true-center bgy" :src="iphone"></v-img>
                <v-container class="preview-cards-container">
                
                <v-card v-if="!separator" elevation="6" class="new-food-tiem-preview-card pa-0">
                IMAGE
                </v-card>
                
                <v-card v-if="separator" elevation="6" class="edit-food-card">
                  Title & Text
                </v-card>
                
                <v-card elevation="6" class="edit-food-card2 pa-0">
                  Allergens
                </v-card>
              
              </v-container>
            </v-container> -->
             
                  <v-container  class="pa-0 ma-0">
                    <!-- <v-img class="" :src="iphone"></v-img> -->
                    <v-row no-gutters class="pa-0 ma-0 cards-container">
                      <v-col cols="12" md="12" class="pa-0 ma-0">
                        <div class="card-title pb-3">{{$t('zz_preview')}}</div>
                        <v-row>
                        <!-- <v-col cols="12" v-for="(item, index) in courseitem" :key="index" class="pl-3">
                          <span class="pa-3 ma-3  true-center">
                              <span class="card-subtitle" style="color:#FE5800">{{item.course}}</span>
                          </span>
                        </v-col> -->
                      </v-row>
                      </v-col>
                      <!-- <v-col cols="2" md="2" class="pa-0 ma-0">
                        <v-switch label="" v-model="showonmenu" color="success"></v-switch>
                      </v-col> -->
                    </v-row>
                    <v-card elevation="5" style="position:relative" class="card-in-cards-container ma-0 pb-12 mb-12" :class="foodstatus=='Feature'?'preview-featueredItem promotion-active':''" width=350px>
                        <template>
<!-- ADD IMAGE                    -->
                          <v-container class="ma-0 pa-0">
                            <v-col class="pa-0 ma-0">
                              <v-row v-if="mainimguploading">
                                <v-col cols="12" class="text-center">
                                  <v-progress-circular
                                      indeterminate
                                      color="primary"
                                    ></v-progress-circular>
                                </v-col>
                              </v-row>
                              <!-- <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/> -->
                              <v-row>
                                <v-col col="12" md="12" sm="12" class="text-center ma-0 pa-0 px-3">
                                  <img
                                    style="max-width:100%"
                                    :src="image"
                                    class="grey lighten-2 pa-0 ma-0 bgr"
                                    max-height="300"
                                    v-if="image!=null"
                                  />
                                </v-col>
                              </v-row>
                              
                              <v-row v-show="uploadedimage==null || uploadedimage=='null' || uploadedimage==''" no-gutters style="justify-content:center" class="ma-0 pa-0">
                                  <v-container style="width:fit-content" class="relative ma-0 pa-0">
                                    <v-img v-if="src!==''"

                                        height="200px"
                                        lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                        max-width="300"
                                        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"

                                    >
                                    <!-- <div>
                                        <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.file.click()">
                                          <v-icon style="font-size:50px">mdi-image-plus</v-icon>
                                        </v-btn>

                                        <input
                                        type="file"
                                        ref="file"
                                        @change="uploadImage($event)"
                                        accept="image/*"
                                        class="d-none"
                                        id="itemimage"
                                        />
                                    </div> -->
                                    </v-img>
                                  </v-container>
                            </v-row>
                              <!-- <v-row no-gutters class="ma-0 pa-0">
                              <v-img v-if="!separator"
                                  lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                  width="400"
                                  src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                              >
                              <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.file.click()">
                                <v-icon style="font-size:50px">mdi-image-plus</v-icon>
                              </v-btn>
                                <input
                                  type="file"
                                  ref="file"
                                  @change="uploadImage($event)"
                                  accept="image/*"
                                  class="d-none"
                                  id="itemimage"
                                />
                              </v-img>
                              </v-row> -->
  <!-- SEPARATOR PREVIEW                              -->
                              <v-row v-if="separator" no-gutters class="ma-0 pa-0">
                                <!-- <v-card elevation="12" class="pa-0 ma-0"> -->
                                <v-img :src="foodcardsbottom" class=""/>
                                <v-col cols="12" class="drink-detail-card-section-headings pa-0 ma-0 py-1">
                                  <p class="separator-title text-center">{{title}}</p>
                                  <p class="separator-subtitle text-center">{{subtitle}}</p>
                                </v-col>
                                <!-- </v-card> -->
                                <v-img :src="foodcardstop" class=""/>


                              </v-row>
                              <!-- <v-row v-if="mainimguploading">
                                <v-col cols="12" class="text-center">
                                  <v-progress-circular
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                                </v-col>
                              </v-row>
                              <span style="top:0px">
                              <Cropper v-show="uploadedimage!=null && uploadedimage!='null'" class="cropper" :src="uploadedimage" @change="onChange"/>
                              </span> -->
                            </v-col>
                        </v-container>
                        <v-row style="positon:relative" no-gutters dense class="">
                          <v-container class="pa-0 ma-0" style="position:relative">
                            <v-img v-if="foodstatus=='From Chef'" :src="cheficonGrid" class="preview-chefribbon-add-new"/>

<!-- PREVIEW TITLE & SUBTITLE 7 CHILLIES  -->
                            <v-container v-if="!separator" class="ma-0 pa-0 pt-3">
                              <v-row class="ma-0 pa-0">
                                <v-col clos="12" class="pa-0 ma-0 px-3">
                                  <div class="card-title">{{title}}</div>
                                  <div class="card-subtitle">{{subtitle}}</div>

                                    <!-- PREVIEW CHILLI & SPICE                        -->
                                    <span v-if="chillispice>0" v-for="n in 5" :key="n" class="pt-1">
                                        <img :src="n<=chillispice?chilli:chillio" height="15" @click="chillispice=n">
                                    </span>

  <!-- PREVIEW DESCRIPTION                          -->
                                  <div class="card-description pa-0 ma-0" v-html="description">
                                  </div>
                                </v-col>
                                </v-row>
                              </v-container>

                              <v-divider class="my-2"></v-divider>

<!--PREVIEW PRICE SECTION                    -->

                              <v-container v-if="!separator" class="pa-0 ma-0">
                            <v-divider class="pb-3"></v-divider>
                            <v-row no-gutters class="">
                              <v-col cols="12" v-for="(item, index) in courseitem" :key="index" class="pl-3">
                              <!-- <v-col cols="12" v-for="(size, indexsize) in food.itemsize" :key="'psz-'+indexsize" class="ma-0 pa-0 pr-3">   -->
                                <v-row no-gutters class="" >
                                  <v-col cols="5" md="5" class="food-text">
                                  <span class="pl-1" v-if="typeof item.course == 'object'">
                                      <span class="course-heading">{{item.course.name}}</span>
                                  </span>
                                  <span class="pl-1" v-else>
                                      <span class="course-heading">{{item.course}}</span>
                                  </span>
                                  <span class="pl-1">
                                      {{item.size}}
                                      </span>
                                  </v-col>
                                  <v-col cols="6" md="6" class="text-right">
                                    <span class="preivew-original-price" v-if="item.special>0 && item.price>0.01">
                                      <span class="preivew-original-price strikethrough text-right mr-1" >
                                            {{parseFloat(item.price).toFixed(2)}}
                                        </span>
                                        <span class="preview-new-price text-right">
                                            {{parseFloat(item.special).toFixed(2)}}
                                        </span>
                                    </span>
                                    <span v-else-if="item.price>0.01" class="preview-new-price">
                                        {{parseFloat(item.price).toFixed(2)}}
                                    </span>
                                  </v-col>
                                  <v-col cols="1" md="1" class="pa-0 ma-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="">
                                          <v-icon size="16" color="#fe5800">mdi-heart</v-icon>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>

                            <!--PREVIEW ALLERGENS                    -->
                              <v-container v-if="!separator" class="ma-0 pa-0 mb-4">
                                <v-row class="ma-0 mb-4">
                                    <v-col cols="12" md="12">
                                    <!-- <div style="color:#FE5800;line-height: 0.5;">{{$t('zz_this_dish_contians_the_following_items')}}</div> -->
                                    <!-- <v-divider class="pb-4 ml-0 mr-0"></v-divider> -->
                                    <p class="detail-card-food-allergen-warning pl-8 pr-8">
                                        {{$t('zz_this_dish_contians_the_following_items')}}</p>
                                    </v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0">
                                  <!-- <v-row v-if="fooditem.allergens.length>0" class="ma-0"> -->
                                    <v-col cols="12" class="pb-15 pl-0 pr-0">
                                    <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                                    </v-col>
                                    <div v-for="(allergen,index) in allergens" :key="index" class="display-allergens pl-3 pr-3">
                                        <span v-if="allergen.selected">
                                          <img :src="allergen.image"  width="20"/>
                                          <br>
                                          <span v-html="allergen.name"></span>
                                        </span>
                                    </div>
                                </v-row>
                              </v-container>

                               <!--PREVIEW DIET                    -->
                                <v-container v-if="!separator" class="ma-0 pa-0">
                                  <v-row class="ma-0">
                                      <v-col cols="12" md="12">


                                      </v-col>
                                  </v-row>
                                  <v-row class="ma-0 pa-0">

                                      <v-col cols="12" class="pb-15 pl-0 pr-0">
                                      <p class="drink-detail-card-section-headings">{{$t('zz_diet_type')}}</p>
                                      </v-col>
                                      <div v-for="(diet,index) in diets" :key="index" class="display-allergens pa-0">

                                          <div v-if="diet.selected" class="text-center pl-3 pr-3 mb-3">
                                            <img :src="diet.photo"  width="20"/>
                                            <br>
                                            <span v-html="diet.name"></span>
                                          </div>

                                      </div>
                                  </v-row>

                                </v-container>

                                <!--PREVIEW MEAT                    -->
                                <v-container v-if="!separator" class="ma-0 pa-0">
                                  <v-row class="ma-0">
                                      <v-col cols="12" md="12">
                                      <!-- <div style="color:#FE5800;line-height: 0.5;">{{$t('zz_this_dish_contians_the_following_items')}}</div> -->
                                      <!-- <v-divider class="pb-4 ml-0 mr-0"></v-divider> -->

                                      </v-col>
                                  </v-row>
                                  <v-row v-if="!separator" class="ma-0 pa-0">
                                  <!-- <v-row v-if="fooditem.allergens.length>0" class="ma-0"> -->
                                      <v-col cols="12" class="pb-15 pl-0 pr-0">
                                      <p class="drink-detail-card-section-headings">{{$t('zz_meat')}}</p>
                                      </v-col>
                                      <div v-for="(meat,index) in meats" :key="index" class="display-allergens pa-0">
                                          <!-- <img class="allergen-icon-animation.shake" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" :src="allergen.image"  width="20" @click.prevent="foodAllergendetails(allergen.id,'allergens')"/> -->
                                          <div v-if="meat.selected" class="text-center pl-3 pr-3 mb-3">
                                            <img :src="meat.image"  width="20"/>
                                            <br>
                                            <span v-html="meat.name"></span>
                                          </div>
                                          <!-- {{allergen.name}} -->
                                      </div>
                                  </v-row>

                                </v-container>

                          </v-container>

                        </v-row>
                    </template>
                  </v-card>
                </v-container>
              </v-card>











<!-- *******************       PREVIEW CARD     ***************************-->
              <!-- <v-card elevation="0" class="d-md-block card-preview overflow-y-auto pa-10 ma-0 bgb" max-height="90vh">
                  <v-container  class="pa-0 ma-0">
                    <v-img style="position:relative" class="true-center" :src="iphone"></v-img>
                    <v-row no-gutters class="pa-0 ma-0 cards-container">
                      <v-col cols="12" md="12" class="pa-0 ma-0">
                        <div class="card-title pb-3">{{$t('zz_preview')}}</div>
                        <v-row>
                      </v-row>
                      </v-col>
                    </v-row>
                    <v-card elevation="5" style="position:relative" class="card-in-cards-container ma-0 pb-12 mb-12" :class="foodstatus=='Feature'?'preview-featueredItem promotion-active':''" width=350px>
                        <template>
ADD IMAGE                   
                          <v-container class="ma-0 pa-0">
                            <v-col class="pa-0 ma-0">
                              <v-row v-if="mainimguploading">
                                <v-col cols="12" class="text-center">
                                  <v-progress-circular
                                      indeterminate
                                      color="primary"
                                    ></v-progress-circular>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col col="12" md="12" sm="12" class="text-center ma-0 pa-0 px-3">
                                  <img
                                    style="max-width:100%"
                                    :src="image"
                                    class="grey lighten-2 pa-0 ma-0 bgr"
                                    max-height="300"
                                    v-if="image!=null"
                                  />
                                </v-col>
                              </v-row>
                              <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange"/>
                              <v-row no-gutters class="ma-0 pa-0">
                              <v-img v-if="!separator"
                                  lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                  width="400"
                                  src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                              >
                              <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.file.click()">
                                <v-icon style="font-size:50px">mdi-image-plus</v-icon>
                              </v-btn>
                                <input
                                  type="file"
                                  ref="file"
                                  @change="uploadImage($event)"
                                  accept="image/*"
                                  class="d-none"
                                  id="itemimage"
                                />
                              </v-img>
                              </v-row>
SEPARATOR PREVIEW                             
                              <v-row v-if="separator" no-gutters class="ma-0 pa-0">
                                <v-img :src="foodcardsbottom" class=""/>
                                <v-col cols="12" class="drink-detail-card-section-headings pa-0 ma-0 py-1">
                                  <p class="separator-title text-center">{{title}}</p>
                                  <p class="separator-subtitle text-center">{{subtitle}}</p>
                                </v-col>
                                <v-img :src="foodcardstop" class=""/>
                              </v-row>
                              </span>
                            </v-col>
                        </v-container>
                        <v-row style="positon:relative" no-gutters dense class="">
                          <v-container class="pa-0 ma-0" style="position:relative">
                            <v-img v-if="foodstatus=='From Chef'" :src="cheficonGrid" class="preview-chefribbon-add-new"/>
PREVIEW TITLE & SUBTITLE 7 CHILLIES 
                            <v-container v-if="!separator" class="ma-0 pa-0 pt-3">
                              <v-row class="ma-0 pa-0">
                                <v-col clos="12" class="pa-0 ma-0 px-3">
                                  <div class="card-title">{{title}}</div>
                                  <div class="card-subtitle">{{subtitle}}</div>
PREVIEW CHILLI & SPICE                       
                                    <span v-if="chillispice>0" v-for="n in 5" :key="n" class="pt-1">
                                        <img :src="n<=chillispice?chilli:chillio" height="15" @click="chillispice=n">
                                    </span>
PREVIEW DESCRIPTION                         
                                  <div class="card-description pa-0 ma-0" v-html="description">
                                  </div>
                                </v-col>
                                </v-row>
                              </v-container>
                              <v-divider class="my-2"></v-divider>
PREVIEW PRICE SECTION                   
                              <v-container v-if="!separator" class="pa-0 ma-0">
                            <v-divider class="pb-3"></v-divider>
                            <v-row no-gutters class="">
                              <v-col cols="12" v-for="(item, index) in courseitem" :key="index" class="pl-3">
                                <v-row no-gutters class="" >
                                  <v-col cols="5" md="5" class="food-text">
                                  <span class="pl-1" v-if="typeof item.course == 'object'">
                                      <span class="course-heading">{{item.course.name}}</span>
                                  </span>
                                  <span class="pl-1" v-else>
                                      <span class="course-heading">{{item.course}}</span>
                                  </span>
                                  <span class="pl-1">
                                      {{item.size}}
                                      </span>
                                  </v-col>
                                  <v-col cols="6" md="6" class="text-right">
                                    <span class="preivew-original-price" v-if="item.special>0 && item.price>0.01">
                                      <span class="preivew-original-price strikethrough text-right mr-1" >
                                            {{parseFloat(item.price).toFixed(2)}}
                                        </span>
                                        <span class="preview-new-price text-right">
                                            {{parseFloat(item.special).toFixed(2)}}
                                        </span>
                                    </span>
                                    <span v-else-if="item.price>0.01" class="preview-new-price">
                                        {{parseFloat(item.price).toFixed(2)}}
                                    </span>
                                  </v-col>
                                  <v-col cols="1" md="1" class="pa-0 ma-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="">
                                          <v-icon size="16" color="#fe5800">mdi-heart</v-icon>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>
PREVIEW ALLERGENS                   
                              <v-container v-if="!separator" class="ma-0 pa-0 mb-4">
                                <v-row class="ma-0 mb-4">
                                    <v-col cols="12" md="12">
                                    <p class="detail-card-food-allergen-warning pl-8 pr-8">
                                        {{$t('zz_this_dish_contians_the_following_items')}}</p>
                                    </v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="12" class="pb-15 pl-0 pr-0">
                                    <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                                    </v-col>
                                    <div v-for="(allergen,index) in allergens" :key="index" class="display-allergens pl-3 pr-3">
                                        <span v-if="allergen.selected">
                                          <img :src="allergen.image"  width="20"/>
                                          <br>
                                          <span v-html="allergen.name"></span>
                                        </span>
                                    </div>
                                </v-row>
                              </v-container>
PREVIEW DIET                   
                                <v-container v-if="!separator" class="ma-0 pa-0">
                                  <v-row class="ma-0">
                                      <v-col cols="12" md="12">
                                      </v-col>
                                  </v-row>
                                  <v-row class="ma-0 pa-0">
                                      <v-col cols="12" class="pb-15 pl-0 pr-0">
                                      <p class="drink-detail-card-section-headings">{{$t('zz_diet_type')}}</p>
                                      </v-col>
                                      <div v-for="(diet,index) in diets" :key="index" class="display-allergens pa-0">
                                          <div v-if="diet.selected" class="text-center pl-3 pr-3 mb-3">
                                            <img :src="diet.photo"  width="20"/>
                                            <br>
                                            <span v-html="diet.name"></span>
                                          </div>
                                      </div>
                                  </v-row>
                                </v-container>
PREVIEW MEAT                   
                                <v-container v-if="!separator" class="ma-0 pa-0">
                                  <v-row class="ma-0">
                                      <v-col cols="12" md="12">
                                      </v-col>
                                  </v-row>
                                  <v-row v-if="!separator" class="ma-0 pa-0">
                                      <v-col cols="12" class="pb-15 pl-0 pr-0">
                                      <p class="drink-detail-card-section-headings">{{$t('zz_meat')}}</p>
                                      </v-col>
                                      <div v-for="(meat,index) in meats" :key="index" class="display-allergens pa-0">
                                     <div v-if="meat.selected" class="text-center pl-3 pr-3 mb-3">
                                            <img :src="meat.image"  width="20"/>
                                            <br>
                                            <span v-html="meat.name"></span>
                                          </div>
                                      </div>
                                  </v-row>
                                </v-container>
                          </v-container>
                        </v-row>
                    </template>
                  </v-card>
                </v-container>
              </v-card>               -->











<!-- *******************            EDITING FOOD ITEM CARDS CONTAINER        ******************* -->
              <v-card  elevation="0" class="pa-0 pb-12 cards-container stacked mb-12"  max-width="70vh">
                <v-container max-width="70vh">
                  <v-col cols="3" md="3">
                    <!-- <v-switch label="" v-model="separator" color="success"></v-switch> -->
                  </v-col>

                  <v-template>

        <!--EDITING Title - Subtitle  -->
        <!-- Title & Subtitle             -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      
                      <v-col cols="12" md="12" class="pt-4 px-3" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_title')}} / {{$t('zz_sub_title')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF1 TITLE & SUBTITLE</div>
                      </v-col>
                      <v-card elevation="12" class="px-3">
                        <v-container>
                            <v-row no-gutters>
                              <v-col cols="12"  class="ma-0 pa-0" >
                                <v-text-field
                                  v-model="title"
                                  name="title"
                                  :label="$t('zz_title')"
                                  required
                                  v-validate="'required|max:100'"
                                  :error-messages="errors.collect('title')"
                                  data-vv-name="title"
                                  class="title"

                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-0 pa-0">
                                <v-text-field
                                  v-model="subtitle"
                                  name="subtitle"
                                  :label="$t('zz_sub_title')"

                                  v-validate="'required|max:100'"
                                  :error-messages="errors.collect('subtitle')"
                                  data-vv-name="subtitle"
                                  class="subtitle"
                                  hint="For example, flowers or used cars"

                                ></v-text-field>
                              </v-col>
                            </v-row>
                        </v-container>
                      </v-card>
                    </v-container>
        <!-- SEPARATOR PREVIEW AND DATA  -->
                    <v-container v-if="separator" class="pa-0 ma-0 true-center">
                      <v-col cols="12" md="12" class="pt-4 pl-3 true-center">
                          <div class="card-title pb-0 ma-0">{{$t('zz_separator')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF10 SEPARATOR TEXT</div>
                          <span class="card-description px-10 pt-5 mx-10" v-html="$t('zz_separator_text')"> </span>
                      </v-col>
                      <v-card elevation="12" class="true-center mt-2" min-width="400">
                        <v-container>
                          <v-row class="ma-3">
                            <v-col cols="12">
                              <v-text-field
                                v-model="title"
                                name="title"
                                :label="$t('zz_title')"
                                required
                                v-validate="'required|max:100'"
                                :error-messages="errors.collect('title')"
                                data-vv-name="title"
                                class="separator-title"
                              ></v-text-field>
                              <v-text-field
                                v-model="subtitle"
                                name="subtitle"
                                :label="$t('zz_sub_title')"
                                required
                                v-validate="'max:100'"
                                :error-messages="errors.collect('subtitle')"
                                data-vv-name="subtitle"
                                class="separator-subtitle"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-container>

        <!-- ADD IMAGE                    -->
                    <v-container class="my-5 pa-0">
                      <v-card elevation="12">
                        <template>
                          <v-container class="ma-0 pa-0">
                            <v-col class="pa-0 ma-0">
                                <v-row v-if="mainimguploading">
                                  <v-col cols="12" class="text-center">
                                    <v-progress-circular
                                        indeterminate
                                        color="primary"
                                      ></v-progress-circular>
                                  </v-col>
                                </v-row>
                                <!-- <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/> -->
                                <v-row>
                                  <!-- <v-col col="12" md="12" sm="12" class="text-center ma-0 pa-0 px-3">
                                    <img
                                      style="max-width:100%"
                                      :src="image"
                                      class="grey lighten-2 pa-0 ma-0 bgr"
                                      max-height="300"
                                      v-if="image!=null"
                                    />
                                  </v-col> -->
                                </v-row>
                                <v-row style="justify-content:space-evenly" class="pa-3 ma-3">
                                  
                                  <v-btn
                                    color="#FE5800"
                                    outlined
                                    x-large
                                    dark
                                    @click="ratio='recommended'"
                                  >
                                    <v-icon>mdi-image-filter-hdr</v-icon>
                                  {{$t('zz_crop_recommended')}}
                                  </v-btn>
                                  <v-btn
                                    color="#FE5800"
                                    outlined
                                    x-large
                                    dark
                                    @click="ratio='square'"
                                  >
                                    <v-icon>mdi-format-wrap-square</v-icon>
                                    {{$t('zz_crop_square')}}
                                  </v-btn>
                                  <v-btn
                                    color="#FE5800"
                                    outlined
                                    x-large
                                    dark
                                    @click="ratio='freehand'"
                                  >
                                    <v-icon>mdi-crop-free</v-icon>
                                    {{$t('zz_crop_freehand')}}
                                  </v-btn>
                                  
                                </v-row>
                                <!-- <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/> -->
                                <v-row  class="">
                                  <Cropper v-if="ratio=='' || ratio=='recommended'" v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper ma-3 pa-3" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/>
                                  <Cropper v-if="ratio=='' || ratio=='square'" v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper ma-3 pa-3" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 1/1}"/>
                                  <Cropper v-if="ratio=='' || ratio=='freehand'" v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper ma-3 pa-3" :src="uploadedimage" @change="onChange"/>
                                </v-row>
                                <v-row v-show="uploadedimage==null || uploadedimage=='null' || uploadedimage==''" no-gutters style="justify-content:center" class="ma-0 pa-0">
                                  <v-img v-if="!separator"
                                      lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                      width="400"
                                      src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                  >
                                  <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.file.click()">
                                    <v-icon style="font-size:50px">mdi-image-plus</v-icon>
                                  </v-btn>
                                    <input
                                      type="file"
                                      ref="file"
                                      @change="uploadImage($event)"
                                      accept="image/*"
                                      class="d-none"
                                      id="itemimage"
                                    />
                                  </v-img>
                                </v-row>
  
                            </v-col>
                          </v-container>
                        </template>
                      </v-card>
                    </v-container>

        <!--EDITING  Chillis Rows     -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-3 pl-3" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_chilli_spice')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF2 CHILLI & SPICE</div>
                      </v-col>
                      <v-card elevation="12" class="side-by-side">
                        <v-container>
                          <v-row no-gutters  align="center" class="price-container pl-1 mx-2">
                            <v-col cols="10">
                              <div>
                                <span v-for="n in 5" :key="n" class="pr-2">
                                    <img :src="n<=chillispice?chilli:chillio" height="25" @click="chillispice=n">
                                </span>
                              </div>
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <span @click="chiliclear" style="color:#FE5800">{{$t('zz_clear_all')}}</span>
                              <v-icon color="red" icon dark class="text-right" style="font-size:17px" @click="chiliclear">mdi-close-outline</v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-container>

        <!--EDITING Description -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-4 pl-3" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_description')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF3 DESCRIPTION</div>
                      </v-col>
                      <v-card elevation="12" class="side-by-side">
                        <v-container>
                          <v-row>
                            <v-col close="12">
                              <editor
                              api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                              initialValue=""
                              v-model="description"
                              :init="editorConfigDescription"
                              class="description"
                              ></editor>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-container>

        <!--EDITING PRICE  -->
                    <v-container  class="pa-0 ma-0">
                      <v-row>
                        <v-col cols="6" md="6" class="pt-4 pl-6" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_price')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF4 PRICES & SIZES</div>
                        </v-col>
                        <!-- <v-col cols="6" md="6" class="pt-6 pr-6">
                            <v-switch style="flex-flow: row-reverse" v-model="showonmenu" color="success" label=""></v-switch>
                        </v-col> -->
                      </v-row>
                      <v-card elevation="12" class="side-by-side">
                        <v-container>
                          <v-row no-gutters v-for="(item, index) in courseitem" :key="index" align="center" class="price-container pl-1 mx-2">

                            <v-col class="ma-0 pa-0 price-text" >
                                <v-combobox
                                  v-model="item.course"
                                  :items="courses"
                                  :label="$t('zz_courses')"
                                  item-text="name"
                                  item-value="id"
                                  :name="'course_id['+index+']'"
                                ></v-combobox>
                            </v-col>
                            <v-col class="ma-0 pa-0 ml-1 price-size-text">
                                <v-text-field
                                  v-model="item.size"
                                  :name="'size['+index+']'"
                                  :label="$t('zz_item_size')"
                                  type="text"
                                  :maxlength="14"
                                  >
                              </v-text-field>
                            </v-col>
                            <v-col class="ma-0 pa-0 ml-1 price-item" style="min-width:100px">
                                <v-text-field
                                  v-model="item.price"
                                  :name="'price['+index+']'"
                                  :label="$t('zz_price')"
                                  type=""
                                  
                                  >
                              </v-text-field>
                            </v-col>
                            <v-col class="ma-0 pa-0 ml-1 price-item" style="min-width:100px">
                                <v-text-field
                                  type=""
                                  v-model="item.special"
                                  :name="'special['+index+']'"
                                  :label="$t('zz_discount')">
                                </v-text-field>
                            </v-col>
                            <v-col justify="right" align="right" class="ma-0 pa-0 ml-3 price-item">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-right py-0">
                                    <v-icon style="position:relative; top:9px; left:0px" color="red" icon dark  class="" @click="courseitem.splice(index, 1)">mdi-close-circle</v-icon>
                                    <!-- <a @click="courseitem.splice(index, 1)"><v-icon  style="color:red">mdi-close</v-icon></a> -->
                                </v-col>
                                <!-- <v-col cols="6" md="6" class="pt-6 pr-6">
                                  <v-switch style="flex-flow: row-reverse" v-model="showonmenu" color="success" label=""></v-switch>
                                </v-col> -->
                            </v-row>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-container class="ma- pa-0">
                          <v-row no-gutters class="ma-0 pa-0">
                            <v-col cols="6" md="6" class="">
                              <v-row>
                                <div class="ma-0 pa-0 pl-8">
                                    <v-dialog
                                    v-model="dialog"
                                    width="800"
                                    v-bind="attrs"
                                    v-on="on">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            x-small
                                            elevation="2"
                                            color="#FE5800"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"

                                            >
                                             <v-icon color="white">mdi-information-variant</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="section-spread text-h1 zzorganebg">
                                                <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-currency-usd-off</v-icon>{{$t('zz_price_explained_title')}}</h1>
                                            </v-card-title>
                                            <p class="pt-5 px-4">
                                                <span v-html="$t('zz_price_explained')">
                                                </span>
                                            </p><br>
                                            <v-divider></v-divider>
                                            <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                        </v-card>
                                    </v-dialog>
          <!-- ADD NEW ITEM BUTTON                              -->
                                </div>
                              </v-row>
                            </v-col>

                            <v-col cols="6" md="6" class="ma-0 pa-0">
                            <v-row no-gutters class="pa-2 ma-2 py-0 mt-0">
                              <v-col cols="12" class="text-right">
                                <span @click.stop="add()" style="color:#FE5800">{{$t('zz_add_new')}} <v-icon class=" pb-0 pt-1 pr-1 mb-2 addnewicon">mdi-plus-circle-outline</v-icon></span>
                              </v-col>
                            </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-container>


        <!--EDITING ALLERGENS  -->
                    <v-container v-if="!separator" class="pa-0 ma-0 mb-4">
                      <v-col cols="12" md="12" class="py-4 pl-3" style="justify-content:space-between">
                        <div class="section-label pb-0 ma-0">{{$t('zz_allergens')}}</div>
                        <div class="english-label-black pt-0 ma-0">AF5 ALLERGENS</div>
                      </v-col>
                      <v-card elevation="12" class="ma-0 pa-3">
                        <v-container class="allergens-grid-container py-0 my-0 px-0 mx-0">
                          <v-row no-gutters>
                            <v-col  v-for="(allergen,index) in allergens" :key="index" class="allergen-icon-grid pa-o ma-1">
                              <v-btn
                                block
                                tile
                                height="45"
                                :outlined="allergen.selected?false:true"
                                color="primary"
                                class="text-center"
                                @click="allergen.selected=!allergen.selected"
                                align="center"

                              >
                                <div style="font-size:10px;" class="d-flex" justify="left">
                                    <span class="ml-auto mr-auto">
                                    <img  :src="allergen.image" height="40" class="py-1 my-1" style="align-content:flex-end"/><br>
                                    <!-- <p v-html="allergen.name"></p> -->
                                    </span>
                                </div>
                                <input
                                  type="checkbox"
                                  :name="'allergens['+index+']'"
                                  v-model="allergen.selected"
                                  :value="allergen.id"
                                  class="d-none"
                                />
                                <div v-bind:style="{ color: activeColor, fontSize: fontSize + 'px' }">
                                <p v-html="allergen.name" class="allergens-label text-cen"></p>
                                </div>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-row  class="tesitng">
                          <v-col cols="12" class="text-right">
                            <span @click="clearallergens" style="color:#FE5800">{{$t('zz_clear_all')}}</span>
                            <v-icon style="position:relative; top:0px; left:0px; font-size:17px" color="red" icon dark>mdi-close-outline</v-icon>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>

        <!--EDITING PROMOTIONAL FEATUERED & CHEFS CHOICE  -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-4 pl-3" style="justify-content:space-between">
                        <div class="section-label pb-0 ma-0">{{$t('zz_promotion')}}</div>
                        <div class="english-label-black pt-0 ma-0">AF6 PROMOTIONAL</div>
                      </v-col>
                      <v-card elevation="12" class="ma-0 pa-3">
                        <v-container class="side-by-side py-0 my-0 px-0 mx-0">
                          <v-row no-gutters justify="space-evenly" class="text-center pa-0 ma-0">
                            <v-col  class="card-in-cards-container-strech">
                              <v-btn
                                tile
                                outlined
                                block
                                :class="foodstatus=='Feature'?'featueredItem promotion-active':''"
                                class="text-left promotionbtn mb-3"
                                @click="changefoodstatus('Feature')"
                                style="font-size:10px;"
                                height="auto"
                                justify="left"
                              >
                                <img :src="retImg" width="50" class="mr-3" />
                                <span >
                                    <strong>{{$t('zz_featured')}}</strong><br>
                                    <span>{{$t('zz_dish_highlighted_by_frame')}}</span>
                                </span>
                              </v-btn>
                            </v-col>

                            <v-col  class="card-in-cards-container-strech">
                              <v-btn
                                tile
                                outlined
                                block
                                :class="foodstatus=='From Chef'?'promotion-active':''"
                                class="text-left promotionbtn"
                                @click="changefoodstatus('From Chef')"
                                style="font-size:10px;"
                                height="auto"
                                justify="left"

                              >
                                <img :src="retImg" width="50" class="mr-3" />
                                <!-- <img :src="chefImg" width="50" class="mr-3" /> -->
                                <span>
                                    <strong>{{$t('zz_chefs_choice')}}</strong><br>
                                    <!-- <span>{{$t('zz_dish_highlighted_by_cheif_beige')}}</span> -->
                                    <v-img :src="cheficonGrid" class="chefribbon"/>
                                </span>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-row>
                          <v-col cols="12" class="text-right">
                              <span @click="clearfoodstatus" style="color:#FE5800">{{$t('zz_clear_all')}}</span>
                            <v-icon style="position:relative; top:0px; left:0px; font-size:17px" color="red" icon dark>mdi-close-outline</v-icon>

                              <!-- <v-btn outlined flat tile color="primary" @click="clearfoodstatus" style="font-size:10px;border:none;">{{$t('zz_clear_status')}}</v-btn> -->
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>

        <!--EDITING DRINK PAIRING  -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-4 pl-3" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_drink_pairing')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF7 DRINK PAIRING</div>
                      </v-col>
                      <v-card elevation="12" class="ma-0 pa-3">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              :label="$t('zz_drink_items')"
                              v-model="drinkitems"
                              name="drinkitems"
                              item-text="name"
                              item-value="id"
                              :items="drinkitm"
                              multiple
                              chips
                              dense
                              outlined
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>

        <!--EDITING DIET TYPE  -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-4 pl-3" style="justify-content:space-between">
                        <div class="section-label pb-0 ma-0">{{$t('zz_diet_type')}}</div>
                        <div class="english-label-black pt-0 ma-0">AF8 DIET TYPE</div>
                      </v-col>
                      <v-card elevation="12" class="ma-0 pa-3">
                        <v-container class="allergens-grid-container py-0 my-0 px-0 mx-0">
                          <v-row no-gutters>
                            <v-col v-for="(diet,index) in diets" :key="index" class="allergen-icon-grid pa-o ma-1">
                                  <!-- <v-btn
                                  block
                                  text
                                  :class="diet.selected?'red--text':''"
                                  class="text-left"
                                  @click="diet.selected=!diet.selected" > -->
                                    <!-- <v-avatar tile height="24" width="24" left  >
                                        <v-img  :src="diet.photo" class="mr-5"></v-img>{{diet.name}}
                                    </v-avatar> -->
                              <v-btn
                                block
                                tile
                                height="70"
                                :outlined="diet.selected?false:true"
                                color="primary"
                                class="text-center"
                                @click="diet.selected=!diet.selected"
                                style="font-size:10px">
                                <div style="font-size:9px;" class="d-flex" justify="center">
                                  <span class="ml-auto mr-auto">
                                  <img  :src="diet.photo" class="" width="36" style="margin-bottom:8px"/><br>
                                  <p v-html="diet.name"></p></span>
                                </div>
                                <input type="checkbox" :name="'diets['+index+']'" v-model="diet.selected"  :value="diet.id" class="d-none"/>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-row>
                          <v-col cols="12" class="text-right">
                              <span @click.stop="cleardiets" style="color:#FE5800">{{$t('zz_clear_all')}}</span>
                            <v-icon style="position:relative; top:0px; left:0px; font-size:17px" color="red" icon dark>mdi-close-outline</v-icon>

                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>

        <!--EDITING DIET TYPE  -->
                    <v-container v-if="!separator" class="pa-0 ma-0">
                      <v-col cols="12" md="12" class="pt-4 pl-3" style="justify-content:space-between">
                          <div class="section-label pb-0 ma-0">{{$t('zz_meat')}}</div>
                          <div class="english-label-black pt-0 ma-0">AF9 MEAT TYPE</div>
                      </v-col>
                      <v-card elevation="12" class="ma-0 pa-3">
                        <v-container class="allergens-grid-container py-0 my-0 px-0 mx-0">
                          <v-row no-gutters>
                            <v-col v-for="(meat,index) in meats" :key="index" class="allergen-icon-grid pa-o ma-1">
                                    <v-btn
                                      block

                                      tile
                                      height="70"
                                      :outlined="meat.selected?false:true"
                                      color="primary"
                                      class="text-center"
                                      @click="meat.selected=!meat.selected"
                                      align="center"
                                    >

                                      <div style="font-size:9px;" class="d-flex" justify="center">
                                        <span class="ml-auto mr-auto">
                                        <img  :src="meat.image" class="" width="36" style="margin-bottom:8px"/><br>
                                        {{meat.name}}</span>
                                    </div>

                                      <input
                                        type="checkbox"
                                        :name="'meats['+index+']'"
                                        v-model="meat.selected"
                                        :value="meat.id"
                                        class="d-none"
                                      />
                                    </v-btn>
                                  </v-col>

                          </v-row>
                        </v-container>
                        <v-row>
                          <v-col cols="12" class="text-right">
                              <span @click="clearmeats" style="color:#FE5800">{{$t('zz_clear_all')}}</span>
                            <v-icon style="position:relative; top:0px; left:0px; font-size:17px" color="red" icon dark>mdi-close-outline</v-icon>

                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>
                  </v-template>
                </v-container>
              </v-card>

<!-- SEPARATOR PREVIEW AND DATA  -->
                


            </v-container>
          </v-container>
        </v-form>
        <v-footer padless fixed class="footer-1">
                <v-row class="py-2 pl-5">
                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="21" large  @click.prevent="submit('exit');$emit('set-dialog');">{{$t('zz_save_and_exit')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click.prevent="submit('exit');$emit('set-dialog');">{{$t('zz_save_and_exit')}}</v-btn>

                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1" color="#FE5800" outlined elevation="21" large  @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1" color="#FE5800" outlined elevation="21" small @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>
                </v-row>
            </v-footer>


        <!-- <v-footer padless fixed class="footer-1">
          <v-row no-gutters>
          <v-col cols="12">
            <v-btn class="px-10 ma-5" color="primary" elevation="21" x-large  @click.prevent="submit('exit');$emit('set-dialog');">{{$t('zz_save_and_exit')}}</v-btn>
              <v-btn class="px-10 ma-5" elevation="1" plain large @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>
          </v-col>
        </v-row>
        </v-footer> -->
      </v-container>
    </v-card>



  </v-container>
</template>


<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import Editor from '@tinymce/tinymce-vue'

import { Cropper } from 'vue-advanced-cropper'

Vue.use(VeeValidate);
export default {
  props: ['cid'],

  data: () => ({
    itemimagedialog:false,

    descriptiondialog:false,
    businessdescriptiondata:[],
    businessdescriptionlanguagecode:"",
    businessdescriptionlanguagecodearr:[],
    businessdescriptiontranslatorarr:[],
    desccriptiontype:"",
    businessdescriptiontranslator:"",
    mainimguploading:false,
    overlay: false,
    languagelist:[{name:"English",value:"en"},
                    {name:"Spanish",value:"es"},
                    {name:"French",value:"fr"},
                    {name:"German",value:"de"},
                    {name:"Russian",value:"ru"},],

    editorData: '',
    editorConfigDescription: {height: 200,
         menubar: false,
        //  plugins: [
        //    'advlist autolink lists link image charmap print preview anchor',
        //    'searchreplace visualblocks code fullscreen',
        //    'insertdatetime media table paste code wordcount autoresize'
        //  ],
         toolbar:
           ' bold italic | alignleft aligncenter alignright alignjustify'
    },
    panelpromotion:[0],
    panelmeat:[0],

    paneldiet:[0],
    panelprice:[0,1,2],
    panelallergen:[0],
    paneldish:[0,1,2],
    panelphoto:[0],
    panel2:[0,1,2],
    panel: [0,1],
    paneldrink:[0,1],
    typeanimal:0,
    meattype:'meat',
    outlined_meat:'outlined',
    outlined_poultry:'outlined',
    outlined_animal:'outlined',

    foodstatus:'Basic',
    retImg:require("@/assets/star-shooting-outline.svg"),
    chefImg:require('@/assets/rectangle-c.svg'),
    addphoto: require("@/assets/addphoto.svg"),
    juzzapLogo: require("@/assets/logo-Copy.png"),
    dishlogo: require("@/assets/dish1.png"),
    chilli:require("@/assets/chili.svg"),
        // chillio:require("@/assets/chili-o.svg"),
    chillio:require("@/assets/chili-plain.svg"),
    cheficonGrid:require('@/assets/chefGrid.svg'),
    foodcardsbottom:require('@/assets/Food-Card-2.png'),
    foodcardstop:require('@/assets/Food-Card-1.png'),
    iphone:require('@/assets/iphone3.svg'),

    logo: require("@/assets/cutlery.png"),
    ratio:'recommended',
    department_id:0,
    departments: [],
    btnColor:"",
    course_id:"",
    valid:true,
    counter: 0,
        title:'',
        subtitle:'',
        description:'',
        showonmenu:true,
        separator:false,
        courseitem:[{'id':'','course':'','special':'','price':'0.001','size':''}],
        courses:[],
        meats:[],

        diets:[],

        allergens:[],

        business_id:0,
        chillispice:0,
        uploadedimage:null,
        image:null,
    coordinates:
    {
				width: 0,
				height: 0,
				left: 0,
				top: 0
    },
    business:"",
    galleries:[{'imageurl':''}],
    imageurl:'',
    imggallery:[],
    files: [],
    poultries:[],
    drinkitems:[],
    drinkitm:[],
    drinkitms:[],
    b_id:0,
    bus:[],
    crs:[],
    translationlanguages:[],
    languagetranslations:[],
    //cid:"",
  }),
  components: {
    'editor': Editor,

		Cropper
	},


  created()
  {

        // this.cid=localStorage.getItem('cid');

        this.storeBusiness=JSON.parse(localStorage.getItem('business'));

        this.business_id=this.storeBusiness.id;
        // if(this.$route.params.id)
        // {
        //     this.business_id=this.$route.params.id;
        // }

        //this code if course id pass from drag and drop food item list add new item.Then that course is selected

        //End course

        var th=this;






        this.$http
        .get(this.$apidomain+"businessdata/"+this.business_id)
        .then(res => {
          if(res.data.success==0)
          {
            this.$router.push({name:'businesslistnew'});
          }

          this.business = res.data.businesses;
          this.translationlanguages=res.data.businesses.translationlanguages;

        })
        .catch(err => {
                console.log(err.response);
        });

        this.fetchDepartments();
        this.fetchCourse();
        this.meatlist();
        this.poultrylist();
        this.fetchdiet();
        this.fetchAllergens();
        this.fetchDrinkItems();

    },
    watch:
    {
      cid:function(value)
        {
            // this.cid="";
            // this.cid=localStorage.getItem('cid');
            if(this.cid)
            {


                  this.overlay=true;

                  this.$http
                  .get(this.$apidomain+"courseData/"+this.cid)
                  .then(res => {
                    if(res.data.success==0)
                    {
                      this.$router.push({name:'businesslistnew'});
                    }

                    this.courseitem=[{'id':this.cid,'course':res.data.course.name,'special':'','price':'0.001','size':''}];

                    this.overlay=false;

                  })
                  .catch(err => {
                          console.log(err.response);
                          this.overlay=false;
                  });

                  // this.courseitem=[{'id':this.cid,'course':'','special':'','price':'0.001','size':''}];

                  // this.courseitem({
                  // 'id':this.cid,
                  // 'course':'',
                  // 'special':'',
                  // 'price':'0.001',
                  // 'size':''
                  // });
            }


            return value;
        }
    },
    mounted()
    {
      // this.cid="";
      // this.cid=localStorage.getItem('cid');
      if(this.cid)
      {


            this.overlay=true;

            this.$http
            .get(this.$apidomain+"courseData/"+this.cid)
            .then(res => {
              if(res.data.success==0)
              {
                this.$router.push({name:'businesslistnew'});
              }

              this.courseitem=[{'id':this.cid,'course':res.data.course.name,'special':'','price':'0.001','size':''}];

              this.overlay=false;

            })
            .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
            });

            // this.courseitem=[{'id':this.cid,'course':'','special':'','price':'0.001','size':''}];

            // this.courseitem({
            // 'id':this.cid,
            // 'course':'',
            // 'special':'',
            // 'price':'0.001',
            // 'size':''
            // });
      }


    },
  methods:
  {
    backtobusiness()
    {
        this.descriptiondialog=false;

    },
    translator()
    {
        this.descriptiondialog=true;
    },
    chiliclear()
    {
      this.chillispice=0;
    },
    clearfoodstatus()
    {
      this.foodstatus='';
    },
    clearallergens()
    {
      this.allergen='';
      this.allergens.forEach(function(it,ind)
        {
            it.selected=false;


        });
    },
    cleardiets()
    {

      this.diets.forEach(function(it,ind)
        {
            it.selected=false;


        });
    },
    clearmeats()
    {
        this.meats.forEach(function(it,ind)
        {
            it.selected=false;


        });
    },
    changemeattype(meattype)
    {
      this.meattype=meattype;
      if(this.meattype=='meat')
      {
        this.outlined_meat='';
        this.outlined_poultry='outlined';
        this.outlined_animal='outlined';
      }else if(this.meattype=='poultry')
      {
        this.outlined_meat='outlined';
        this.outlined_poultry='';
        this.outlined_animal='outlined';
      }else if(this.meattype=='animal')
      {
        this.outlined_meat='outlined';
        this.outlined_poultry='outlined';
        this.outlined_animal='';
      }
    },
    changefoodstatus(foodstatus)
    {
      this.foodstatus=foodstatus;
    },

    fetchDrinkItems()
    {
      this.$http
      .get(this.$apidomain+"drinkitems/"+this.business_id)
      .then(res => {
          this.drinkitm = res.data.drinkitems;
      })
      .catch(err => {
        console.log(err.response);
      });
    },

    fetchDepartments()
    {
      this.$http
      .get(this.$apidomain+"departmentList/"+this.business_id)
      .then(res => {
          this.departments = res.data.departments;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    add()
    {
      this.courseitem.push({
      'id':'',
      'course':'',
      'special':'',
      'price':'0.001',
      'size':''
      })
    },
    onChange({coordinates, canvas}) {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
      this.image = canvas.toDataURL()
      this.mainimguploading=false;
    },
    uploadImage(event) {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {

          this.mainimguploading=true;
					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
    },
    meatlist()
    {
      this.$http
      .get(this.$apidomain+"meatListpwa")
      .then(res => {
          this.meats = res.data.meats;

          // this.selectedmeats = this.meats.map(() => false);

      })
      .catch(err => {
          console.log(err.response);
      });

    },
    poultrylist()
    {
      this.$http
      .get(this.$apidomain+"poultryList")
      .then(res => {
          this.poultries = res.data.poultrys;

          // this.selectedmeats = this.meats.map(() => false);

      })
      .catch(err => {
          console.log(err.response);
      });
    },
    fetchDepartments()
    {
            this.$http
            .get(this.$apidomain+"departmentList/"+this.business_id)
            .then(res => {
                this.departments = res.data.departments;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    fetchCourse()
    {

            if(localStorage.getItem('business'))
                {
                    this.bus=JSON.parse(localStorage.getItem('business'));
                    //fd.append('business_id',this.business['id']);
                    this.b_id=this.bus['id'];

                }
                else
                {
                    //fd.append('business_id',0);
                    this.b_id=0;

                }

            this.$http
            .get(this.$apidomain+"courselistnewpwa/"+this.b_id)
            .then(res => {
                this.courses = res.data.course;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    fetchAllergens()
    {
            this.$http
            .get(this.$apidomain+"allergenslist")
            .then(res => {
                this.allergens = res.data.allergens;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    fetchdiet()
    {
            this.$http
            .get(this.$apidomain+"dietListpwa")
            .then(res => {
                this.diets = res.data.diets;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    addgallery()
    {
         this.galleries.push({'imageurl':''})
    },
    dataURLtoFile(dataurl, filename)
    {


            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
    },

    submit(param)
    {
      let th = this;
      if (this.$validator.validateAll())
      {

        th.crs=JSON.stringify(this.courseitem);

        console.log('citem '+JSON.stringify(this.courseitem)+' crsid '+th.crs);


        let fd = new FormData(document.getElementById("createitem"));



        fd.append('citem',JSON.stringify(this.courseitem));


        fd.append('business_id',this.business_id);

        fd.append('foodstatus',this.foodstatus);

        //fd.append('courseitems',JSON.stringify(this.courseitem));

        fd.append('drinkitems',JSON.stringify(this.drinkitems));

        fd.append('chillispice',this.chillispice);

        fd.append('description',this.description);

        if(this.showonmenu)
        {
          fd.append('showonmenu',1);
        }
        else{
          fd.append('showonmenu',0);

        }

        if(this.separator)
        {
          fd.append('separator',1);

        }
        else
        {
          fd.append('separator',0);
        }

        this.overlay=true;

        if(this.uploadedimage!=null)
        {

          fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
        }
        this.$http
        .post(this.$apidomain+"createItem", fd)
        .then(res =>
        {
          if(res.data.success==1)
          {
              this.overlay=false;

              // if(param=='newitem')
              // {
              //   //this.$refs.form.reset();
              //   console.log('param');
              //   //this.$forceUpdate();
              //   this.$router.go('/');
              //   //this.$router.push("/createfooditem/"+this.business_id);

              // }else
              // {


              //   //this.$router.push("/businessfoodlist/"+this.business_id);
              //   // this.$router.push({name:'businessfoodlist'});
              //   // this.$router.go('/');

              // }
              this.$router.go("/");
          }

          else if(res.data.success==3)
          {
            alert('Hey, It looks like you have not selected which course this item belongs too…');
            this.overlay=false;
            let inputID = document.querySelector(".course_container input").id;
             //let labelID = document.querySelector(".course_container label").getAttribute('for');
             //alert(labelID);
             //this.course_id[0].focus();
            document.getElementById(inputID).parentElement.parentElement.parentElement.parentElement.setAttribute( 'class', 'v-input--is-focused v-input--is-focused theme--light v-text-field v-text-field--is-booted primary--text' );
            //document.getElementById(labelID).parentElement.parentElement.parentElement.parentElement.setAttribute( 'class', 'v-label--active theme--light primary--text' );
           // document.getElementById(inputID).parentElement.parentElement.parentElement.parentElement.focus();

            //document.getElementById(inputID).parentElement.parentElement.parentElement.focus();
            //document.getElementsByClassName('course_container').find('input').css('v-input--is-focused');
            //document.querySelector('input.course-control[type=text]').focus();

          }
          else if(res.data.success==4)
          {
            alert('Hey, It looks like you have not selected which diets this item belongs too…');
            this.overlay=false;

          }
          else
          {
            let errmsg=[];
            for(var prop in res.data.errors)
            {
                  errmsg.push(res.data.errors[prop][0]);
            }
            alert(errmsg[0]);
            this.overlay=false;

          }
        })
        .catch(err => {
          this.overlay=false;

          console.log(err.response);
        });
      }
    },
  }
};
</script>
<style scoped>
.cropper {
  border: solid 1px #eee;
  height: 300px;
  width: 100%;
}

.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
.promotionbtn .v-btn__content{
  justify-content: left;
  padding: 12px 0px;
}


.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 100px;
  background-color: rgb(255, 238, 0);
  color: rgb(0, 0, 0);
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  z-index: 100;
  /* width: 120px; */
  bottom: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.preview-chefribbon-add-new{

        position: absolute;
        top: -4px;
        right: 11px;
        width: 60px;
        z-index: 3;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }
.hidden-Food-Item{
  opacity: .5 !important;
}
.hidden-notice{
  color: #FE5800;
  flex-wrap: wrap;
  padding-top: 30px;
  font-size: 25px;
  font-weight: 800;

}
.new-food-tiem-preview-card{
    /* position: absolute; */
    /* top: 10px; */
    z-index:4;
    flex: 1 1 350px;
    width: 90%;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    }
.edit-food-card{
    /* position: absolute; */
    /* top: 10px; */
    z-index:4;
    flex: 1 1 350px;
    width: 100%;
    justify-content: center;
    
}    
.edit-food-card2{
    /* position: absolute; */
    /* top: 300px; */
    margin-top: 15px;
    z-index:4;
    flex: 1 1 350px;
    width: 90%;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.5;
    
}  
.card-preview{
  position: sticky;
  top: 10px;
}  
.english-label-black{
    font-size: 10px;
    color: #414141;
}
</style>
